import React, { useState, useEffect } from 'react';
import Button from '../Button/Button';
import Popup from '../Popup/Popup';
import LoginForm from '../Forms/LoginForm/LoginForm';

// @ts-ignore
import styles from './LoginButtonSpan.module.scss?module';

export default function LoginButtonSpan({ className }: { className?: string }) {
  const [showLoginPopup, setShowLoginPopup] = useState(false);

  return (
    <span className={`${className}`}>
      <Button
        onClick={() => {
          setShowLoginPopup(true);
        }}
      >
        LOG IN
      </Button>

      <Popup
        centered
        show={showLoginPopup}
        onHide={() => {
          setShowLoginPopup(false);
        }}
      >
        <div className={'p-5'}>
          <h2 style={{ fontStyle: 'italic' }} className={'pb-3 fw-black'}>
            Account login
          </h2>
          <LoginForm />
        </div>
      </Popup>
    </span>
  );
}
